export default __webpack_public_path__ + "static/media/home-title.3cad7c77.png";